import { theme } from '../../../Assets/Styles/theme'

const styles = () => ({
  container: {
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'row',
  },
  datePickerHeaderTitle: {
    color: theme.colors.regentGray,
    fontSize: 14,
    alignSelf: 'center',
    fontWeight: 700,
    marginRight: 10,
  },
  dots: {
    margin: '0 0.5rem',
  },
  timeContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '7rem',
    padding: '0.6rem',
    border: `1px solid ${theme.colors.iron}`,
  },
  input: {
    textAlign: 'center',
    '& .MuiInput-root': {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
    '& .MuiInput-input': {
      color: '#546b81',
      padding: 0,
    },
    '& .MuiInput-underline:before': {
      display: 'none',
    },
    '& .MuiInput-underline:after': {
      display: 'none',
    },
  },
  hoursInput: {
    '& .MuiInput-root': {
      width: '1.2rem',
    },
  },
  minutesInput: {
    '& .MuiInput-root': {
      width: '1.7rem',
    },
  },
  optionsContainer: {
    display: 'flex',
    flexDirection: 'row',
    marginLeft: '0.5rem',
  },
})

export default styles
